//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepertoireAssignmentStatus } from './Enums';

export class RepertoireAssignmentInputItem extends ItemBase {
    Status: RepertoireAssignmentStatus = RepertoireAssignmentStatus.InProgress;
    Notes: string | null = null;
    StartDate: string | null = null;
    EndDate: string | null = null;

    constructor(initializer?: Partial<RepertoireAssignmentInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoireAssignmentInputItem";
}
